/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import { IToast, IdeviceCount, IhelperInitialState, IPaginationModel } from "./types";
import { IKeyBoolean, IKeyValue } from "../../components/Administrations/types";
import { IVersion } from "../api/admin/types";
import { GridRowModesModel } from "@mui/x-data-grid-pro";
import { LOCAL_STORAGE } from "../../globals/globals";

export const setOpenToastAction = (state: IhelperInitialState, action: PayloadAction<IToast>) => {
  state.toastDetail.openToast = action.payload?.openToast;
  state.toastDetail.message = action?.payload?.message || "";
  state.toastDetail.toastType = action.payload?.toastType || "";
};
export const setConfirmDialogAction = (state: IhelperInitialState, action: PayloadAction<string | undefined | null>) => {
  state.openConfirmDialog = action.payload;
};

export const setBasicDialogAction = (state: IhelperInitialState, action: PayloadAction<string | undefined | null>) => {
  state.basicDialogOpenFor = action.payload;
};

export const setOpenCustomDailogAction = (state: IhelperInitialState, action: PayloadAction<boolean>) => {
  state.openCustomDialog = action.payload;
};

export const setDeviceCountAction = (state: IhelperInitialState, action: PayloadAction<IdeviceCount>) => {
  state.deviceCount = { ...action.payload };
};

export const setSelectedNavListItemsAction = (state: IhelperInitialState, action: PayloadAction<string>) => {
  state.selectedNavListItems.nodeItemIndex = action.payload;
  localStorage.setItem(LOCAL_STORAGE.SELECTED_NAV_ITEM, action.payload);
};

export const setPaginationModelAction = (state: IhelperInitialState, action: PayloadAction<IPaginationModel>) => {
 state.paginationModel = { ...state.paginationModel, ...action.payload };
};

export const resetPaginationModelAction = (state: IhelperInitialState) => {
  state.paginationModel = {};
};

export const setDataGridSortAction = (state: IhelperInitialState, action: PayloadAction<IKeyValue>) => {
  state.sortModel = { ...state.sortModel, ...action.payload };
};

export const setBasicPopoverAnchorElAction = (state: IhelperInitialState, action: PayloadAction<HTMLElement | null>) => {
  state.basicPopoverAnchorEl = action.payload;
};

export const setConfigAlertCountAction = (state: IhelperInitialState, action: PayloadAction<number>) => {
  state.configAlertCount = action.payload;
};

export const setNotrificationCountAction = (state: IhelperInitialState, action: PayloadAction<number>) => {
  state.notificationCount = action.payload;
};

export const setTimeoutDialogAction = (state: IhelperInitialState, action: PayloadAction<boolean>) => {
  state.openTimeoutDialog = action.payload;
};

export const setActiveTabAction = (state: IhelperInitialState, action: PayloadAction<number>) => {
  state.activeTab = action.payload;
};

export const setActiveMainTabAction = (state: IhelperInitialState, action: PayloadAction<string>) => {
  state.activeMainTab = action.payload;
};

export const setAlarmsCountAction = (state: IhelperInitialState, action: PayloadAction<number>) => {
  state.alarmsCount = action.payload;
};

export const setErrorMsgAction = (state: IhelperInitialState, action: PayloadAction<IKeyValue>) => {
  state.errorMsg = action.payload;
};

export const setVersionDataAction = (state: IhelperInitialState, action: PayloadAction<IVersion>) => {
  state.versionData = action.payload;
};

export const setIsLoadingStatusAction = (state: IhelperInitialState, action: PayloadAction<IKeyBoolean>) => {
  state.isLoadingStatus = { ...state.isLoadingStatus, ...action.payload };
};

export const setRowModesModelAction = (state: IhelperInitialState, action: PayloadAction<GridRowModesModel>) => {
  state.rowModesModel = action.payload;
};
export const setServerMaintenanceModeAction = (state: IhelperInitialState, action: PayloadAction<boolean>) => {
  state.serverMaintenanceMode = action.payload;
};
